// Pure, DOM-free helpers for the Primary-email settings section. Kept separate
// from settings.ts (which pulls in DOM/WebAuthn modules) so they're unit-testable
// under node:test without a DOM.

// Friendly copy for the email-verification error codes surfaced by the API.
// Anything unmapped falls through to the server's own message (or a generic).
export function emailErrorMessage(code: string, fallback?: string): string {
  switch (code) {
    case 'EMAIL_INVALID': return 'That email address looks invalid.';
    case 'EMAIL_TAKEN': return 'That email is already verified on another account.';
    case 'CODE_INVALID': return 'Incorrect code';
    case 'CODE_EXPIRED': return 'Code expired — resend a new one';
    case 'CODE_LOCKED': return 'Too many attempts — resend a new code';
    case 'RESEND_TOO_SOON': return 'Please wait before requesting another email.';
    default: return fallback || 'Something went wrong.';
  }
}

// Seconds until an ISO timestamp (rounded up). null / past => 0 (ready now).
export function resendSecondsRemaining(resend_available_at: string | null, nowMs = Date.now()): number {
  if (!resend_available_at) return 0;
  const diff = new Date(resend_available_at).getTime() - nowMs;
  return diff <= 0 ? 0 : Math.ceil(diff / 1000);
}
